// production
export const featureToggles = {
  workExperience: false,
  jobBoardSettingsAdmins: false,
  billingGating: true,
};
